import React, { useEffect, useState } from "react"
import { Link } from "react-router-dom"
import Stepper from "./stepper"
import moment from "moment"
import Spinner from "../spinner"
import { ToastContainer, toast } from 'react-toastify'
import axios from "axios"
import saveLead from "../../Config/GlobalFunctions"
import configData from "../../config.json"
import { useNavigate } from 'react-router-dom';

function Career() {
  const [gradoAcademico, setGradoAcademico] = useState('BAC')
  const [loading, setLoading] = useState(false)
  const [sede, setSede] = useState([])
  const [sedeId, setSedeId] = useState()
  const [carrera, setCarrera] = useState([])
  const [careerDescription, setCareerDescription] = useState('0')
  const [carreraId, setCarreraId] = useState('0')
  const [enfasis, setEnfasis] = useState([])
  const [enfasisId, setEnfasisId] = useState()
  const [plan, setPlan] = useState([])
  const [planId, setPlanId] = useState()
  const [continueStep, setContinueStep] = useState(false)
  const [Url, setUrl] = useState('')
  const navigate = useNavigate()

  const handleSubmit = (e) => {
    e.preventDefault()
    const data = JSON.parse(sessionStorage.getItem('lead'))
    data.FECHA_INGRESO = ''
    data.ETAPA = 'Selección programa de interés'
    data.M05COD = sedeId
    data.M02COD = carreraId
    data.M03COD = enfasisId
    data.M04COD = planId
    data.M07COD = gradoAcademico
    sessionStorage.setItem('lead', JSON.stringify(data))
    saveLead()
    Formalice()
  }

  const handleCareer = (e) => {
    setCarreraId(e.target.value)
    const select = document.getElementById(e.target.id)
    setCareerDescription(select.options[select.selectedIndex].text)
    GetEmphasis(e.target.value).then(emphasis => {
      setEnfasis(emphasis)
      setEnfasisId(emphasis[0].M03COD)
      GetPlan(e.target.value, emphasis[0].M03COD, gradoAcademico).then(response => {
        setPlan(response)
        setPlanId(response[0].M04COD)
        GetSede(e.target.value, emphasis[0].M03COD, gradoAcademico, response[0].M04COD)
      })
    })

  }

  const handleEmphasis = (e) => {
    const value = e.target.value
    console.log(value)
    setEnfasisId(value)
    GetPlan(carreraId, value, gradoAcademico).then(response => {
      setPlan(response)
      setPlanId(response[0].M04COD)
      GetSede(carreraId, value, gradoAcademico, response[0].M04COD)
    })
  }

  const handlePlan = (e) => {
    setPlanId(e.target.value)
    GetSede(carreraId, enfasisId, gradoAcademico, e.target.value)
  }

  const handleSede = (e) => {
    setSedeId(e.target.value)
  }

  const handleGA = (e) => {
    e.preventDefault()
    setGradoAcademico(e.target.getAttribute('value'))
    GetCareer(e.target.getAttribute('value'))
  }


  const Formalice = () => {
    let _data = {
      "student": JSON.parse(localStorage.getItem('info')),
      "info": {
        "AcademicGrade": gradoAcademico,
        "AcademicGradeDescription": '',
        "isNationalTitle": true,
        "Campus": sedeId,
        "CampusDescription": '',
        "Career": carreraId,
        "CareerDescription": careerDescription,
        "Emphasis": enfasisId,
        "EmphasisDescription": '',
        "Plan": planId,
        "PlanDescription": ''
      },
      "adequacy": JSON.parse(sessionStorage.getItem('adecuacy'))
    }

    setLoading(true)
    console.log(JSON.stringify(_data))
    axios.post(`${configData.API_URL}/data/finish`, _data)
      .then(response => {
        sessionStorage.setItem('resume', JSON.stringify(response.data))
        navigate('/information/resume', { replace: true });
      })
      .catch(error => {
        console.log('Error:', error);
      });
  }

  useEffect(() => {
    GetCareer(gradoAcademico)
  }, [])

  const GetCareer = (ga) => {
    setLoading(true)

    axios.get(`${configData.API_URL}/data/carrera/${ga}`)
      .then(response => {

        if (response.data.length > 0) {
          setCarrera(response.data)
          setCarreraId('0')
          setEnfasisId('0')
          setPlanId('0')
          setSedeId('0')
          setContinueStep(false)
          setLoading(false)
        }
        else {
          setCarreraId('0')
          setCarrera([])
          setEnfasisId('0')
          setEnfasis([])
          setPlanId('0')
          setPlan([])
          setSedeId('0')
          setSede([])
          setContinueStep(false)
          toast.info('No hay carreras ofertadas para el grado academico seleccionado', {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          })
          setLoading(false)
        }
      })
      .catch(error => {
        console.log(error);
      })

  }

  const GetEmphasis = (carreraId) => {
    setLoading(true)
    return axios.get(`${configData.API_URL}/data/enfasis/${carreraId}/${gradoAcademico}`)
      .then(response => {
        return response.data
      })
      .catch(error => {
        console.log(error);
      })

  }

  const GetSede = (carreraId, enfasisId, gradoAcademico, planId) => {
    setLoading(true)
    console.log(carreraId+ ' '+ enfasisId+ ' '+ gradoAcademico + ' '+planId)
    axios.get(`${configData.API_URL}/data/sedes/${carreraId}/${enfasisId}/${gradoAcademico}/${planId}`)
      .then(res => {
        setSede(res.data)
        setSedeId(res.data[0].M05COD)
        GetLink(res.data[0].M05COD, carreraId, enfasisId, planId, gradoAcademico).then(response => {
          setUrl(response)
          setContinueStep(true)
          setLoading(false)
        })

      })
      .catch(error => {
        console.log(error);
      })

  }


  const GetPlan = (carreraId, enfasisId, gradoAcademico) => {
    setLoading(true)
    return axios.get(`${configData.API_URL}/data/plan/${carreraId}/${enfasisId}/${gradoAcademico}`)
      .then(response => {
        
        return response.data
      })
      .catch(error => {
        console.log(error)
      })

  }

  const GetLink = (sedeId, carreraId, enfasisId, planId, gradoAcademico) => {
    setLoading(true)
    console.log(sedeId)
    return axios.get(`${configData.API_URL}/data/obtienePlanEstudio/${sedeId}/${carreraId}/${enfasisId}/${planId}/${gradoAcademico}`)
      .then(response => {
        console.log(response.data)
        return response.data
      })
      .catch(error => {
        console.log(error);
      })

  }

  return (
    <div>
      <Spinner show={loading}></Spinner>
      <Stepper step="3" ></Stepper>
      <section className="text-center container-fluid">
        <div className="modal fade" tabindex="-1" id="mi-modal">
          <div className="modal-dialog modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
              </div>
              <div className="modal-body">
                <p>¡Listo! Vamos a crear tu carnet institucional. Solicitamos nos confirmés presionando el botón.</p>
              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-lg btn-red" data-bs-dismiss="modal">Cancelar</button>
                <button className={`btn btn-lg btn-green ${!continueStep ? "disabled" : ""}`}  data-bs-toggle="modal" data-bs-target="#mi-modal" onClick={handleSubmit}>Confirmar</button>
              </div>
            </div>
          </div>
        </div>
        <ToastContainer
          position="top-right"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="light"
        />
        {/* Same as */}
        <ToastContainer />

        <div className="row text-center">
          <div className="offset-lg-3 col-lg-6 mt-5 mb-4 col-sm-12">
            <div className="row">
              <div className="col-lg-2 col-sm-12">
                Grado Académico
              </div>
              <div className="col-lg-5 col-sm-12">
                <button className={`btn w-100 ${gradoAcademico == 'BAC' ? 'btn-green' : 'btn-light'}`} onClick={handleGA} value="BAC">Bachillerato</button>
              </div>
              <div className="col-lg-5 col-sm-12">
                <button className={`btn w-100 ${gradoAcademico == 'LIC' ? 'btn-green' : 'btn-light'}`} onClick={handleGA} value="LIC">Licenciatura</button>
              </div>
            </div>
            <div className="row mt-5">
              <div className="col-lg-6 col-sm-12">
                <label for="EstadoCivil" className="form-label float-start">Carrera</label>
                <select value={carreraId} name="" className="form-select" id="EstadoCivil" placeholder="Selecciona la sede de interés" onChange={handleCareer}>
                  <option value='0' selected disabled>Selecciona la carrera</option>
                  {carrera.map(option => (
                    <option key={option.M02COD} value={option.M02COD}>{option.M02DES}</option>
                  ))}
                </select>
              </div>
              <div className="col-lg-6 col-sm-12">
                <label for="EstadoCivil" className="form-label float-start">Énfasis</label>
                <select value={enfasisId} name="" className="form-select" id="EstadoCivil" placeholder="Selecciona la sede de interés" onChange={handleEmphasis}>
                  <option value={'0'} disabled selected>Selecciona el énfasis</option>
                  {enfasis.map(option => (
                    <option key={option.M03COD} value={option.M03COD}>{option.M03DES}</option>
                  ))}
                </select>
              </div>
              <div className="col-lg-6 col-sm-12">
                <label for="EstadoCivil" className="form-label float-start">Plan</label>
                <select value={planId} name="" className="form-control form-select" id="EstadoCivil" placeholder="Selecciona la sede de interés" onChange={handlePlan}>
                  <option value={'0'} disabled selected>Selecciona el plan</option>
                  {plan.map(option => (
                    <option key={option.M04COD} value={option.M04COD}>{option.M04DES}</option>
                  ))}
                </select>
              </div>
              <div className="col-lg-6 col-sm-12">
                <label for="EstadoCivil" className="form-label float-start">Sede</label>
                <select value={sedeId} name="" className="form-select" id="EstadoCivil" placeholder="Selecciona la sede de interés" onChange={handleSede}>
                  <option value={'0'} disabled selected>Selecciona la sede</option>
                  {sede.map(option => (
                    <option key={option.M05COD} value={option.M05COD}>{option.M05DES}</option>
                  ))}
                </select>
              </div>
            </div>
          </div>
        </div>
        <div className="row pb-1 text-center">
          <div className={`pt-2 offset-lg-3 col-lg-6 col-sm-12 ${Url == '' ? 'd-none' : ''}`}>
            <a href={Url} target="_blank">Aquí</a> podés ver el plan de estudios.
          </div>
        </div>

        <div className="row pt-2 pt-5 pb-5">
          <div className="pt-2 offset-lg-3 col-lg-3 col-sm-12 text-center">
            <Link className="btn btn-lg w-100 btn-red" to="/information/terms">Regresar</Link>
          </div>
          <div className="pt-2 col-lg-3 col-sm-12 text-center">
            <a className={`btn btn-lg w-100 btn-yellow ${!continueStep ? "disabled" : ""}`} disabled={continueStep} data-bs-toggle="modal" data-bs-target="#mi-modal">Continuar</a>
          </div>
        </div>


      </section>
    </div>
  )
}

export default Career